import produce from 'immer'
import { Reducer } from 'redux';

import { AOLConfig, AOLMenu, AOLPage, AvailbleAOL } from 'interfaces/aol';
import {
  SET_AOL_CONFIG_LOADED,
  SET_AOL_CONFIG_MAP,
  SET_AOL_FOOTER_MENU,
  SET_AOL_HEADER_MENU,
  SET_AOL_NAME,
  SET_AOL_PAGE_RULES,
  SET_AOL_SEARCH_MENU,
  SET_AVAILABLE_AOL
} from 'redux/actions/types'
import { AOLType } from 'types/AOL';

interface AOLState {
  name: string|null;
  availableAol: AvailbleAOL[];
  pages: Record<string, AOLPage>;
  headerMenu: AOLMenu[];
  searchMenu: AOLMenu[];
  footerMenu: AOLMenu[];
  aolConfigMap: Record<AOLType, AOLConfig>|null;
  aolConfigLoaded: boolean;
}

const initialState: AOLState = {
  name: null,
  availableAol: [],
  pages: {}, // we can use the page controller as the key for O(1) look ups
  headerMenu: [],
  searchMenu: [],
  footerMenu: [],
  aolConfigMap: null, // using null to identify that the map hasn't loaded yet
  aolConfigLoaded: false
}

const aol:Reducer<AOLState, any> = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_AOL_NAME:
      return produce(state, draft => {
        draft.name = action.name
      })
    case SET_AVAILABLE_AOL:
      return produce(state, draft => {
        draft.availableAol = action.availableAol
      })
    case SET_AOL_CONFIG_MAP:
      return produce(state, draft => {
        draft.aolConfigMap = action.aolConfigMap
      })
    case SET_AOL_HEADER_MENU:
      return produce(state, draft => {
        draft.headerMenu = action.headerMenu
      })
    case SET_AOL_FOOTER_MENU:
      return produce(state, draft => {
        draft.footerMenu = action.footerMenu
      })
    case SET_AOL_SEARCH_MENU:
      return produce(state, draft => {
        draft.searchMenu = action.searchMenu
      })
    case SET_AOL_PAGE_RULES:
      return produce(state, draft => {
        draft.pages = action.pages
      })
    case SET_AOL_CONFIG_LOADED:
      return produce(state, draft => {
        draft.aolConfigLoaded = action.aolConfigLoaded
      })
    default:
      return state
  }
}

export default aol
